<template>
  <div @click="shutDown" v-cloak>
    <appheader index="1"></appheader>
    <div class="shoppingCart">
      <div class="shoppingCart_head">
        <div
          style="font-size: 24px; color: #000; margin-top: 34px;display:flex;align-items: center;"
        >
          <p>我的购物车</p>
          <div style="font-size: 22px; color: #ec9368;margin-left:10px">
            全部商品({{ cartNumber }})
          </div>
        </div>
        <div style="display:flex;margin-top: 34px">
          <div style="margin-left:30px">
            <el-input
              placeholder="请输入款号"
              prefix-icon="el-icon-search"
              v-model="searchStyleNumber"
              @keyup.enter.native="getsearchCart()"
              clearable
            ></el-input>
          </div>
          <div class="searchClass" @click="getsearchCart()">搜索</div>
        </div>
      </div>
      <div v-if="withWithoutShow">
        <div v-for="(item, index) in shoppingCart" :key="index">
          <div class="shoppingCart_bodyFather">
            <div class="shoppingCart_body">
              <div class="checkBoxHade">
                <el-checkbox
                  v-model="item.flag"
                  @change="changeCheckbox(index, item)"
                ></el-checkbox>
              </div>
              <div class="statusImg">
                <img
                  src="../../Img/customMade.png"
                  alt
                  v-if="item.imgShow == false"
                />
                <img
                  src="../../Img/spotImg.png"
                  alt
                  v-if="item.imgShow == true"
                />
              </div>
              <div class="shoppingCart_body_child">
                <img
                  :src="item[0].imgPath"
                  alt
                  width="100%"
                  height="100%"
                  @click.stop="transferImgSrc(item[0].imgPath, item)"
                />
                <!-- 图片放大容器 -->
                <div class="pictureZoom" v-if="item.pictureZoomShow">
                  <img :src="pictureZoom" alt />
                </div>
              </div>
              <div style="margin-left:8px;font-size:14px;">
                <div class="shoppingCart_body_text" style="margin-left:20px">
                  <div class="styleShopClass marginClass" style="width:80px">
                    款号
                  </div>
                  <div class="styleShopClass marginClass" style="width:72px">
                    品类
                  </div>
                  <div class="styleShopClass marginClass" style="width:100px">
                    材质
                  </div>
                  <div class="styleShopClass marginClass" style="width:65px">
                    分色
                  </div>
                  <div class="styleShopClass marginClass" style="width:95px">
                    金重范围
                  </div>
                  <div class="styleShopClass marginClass" style="width:110px">
                    价格范围
                  </div>
                  <div class="styleShopClass marginClass" style="width:90px">
                    尺寸
                  </div>
                  <div class="styleShopClass marginClass" style="width:55px">
                    扣子
                  </div>
                  <div class="styleShopClass marginClass" style="width:70px">
                    是否可调节
                  </div>
                  <div class="styleShopClass marginClass" style="width:100px;">
                    商品数量
                  </div>
                  <div class="styleShopClass marginClass" style="width:100px;">
                    备注
                  </div>
                </div>
                <div
                  v-for="(arrly, idx) in item"
                  :key="idx"
                  class="shoppingCart_body_text shoppingCart_body_background"
                  style="color:#ec9368;border-bottom:1px solid #DCDFE6;padding:10px 0"
                >
                  <div class="childecked">
                    <el-checkbox
                      v-model="arrly.innerLayer"
                      @change="innerLayer(index, arrly, item, idx)"
                    ></el-checkbox>
                  </div>
                  <!-- 款号 -->
                  <div
                    v-text="arrly.styleNumber"
                    class="styleShopClass"
                    style="width:80px"
                  ></div>
                  <!-- 品类 -->
                  <div
                    class="styleShopClass"
                    style="width:72px"
                    v-if="!arrly.gender"
                  >
                    {{ arrly.category }}
                  </div>
                  <div
                    class="styleShopClass"
                    style="width:72px"
                    v-if="arrly.gender"
                  >
                    {{ arrly.category }}-{{ arrly.gender }}
                  </div>
                  <!-- 材质 -->
                  <div style="width:100px" class="styleShopClass">
                    {{ arrly.texture }}
                  </div>
                  <!-- 分色 -->
                  <div style="width:65px" class="styleShopClass">
                    {{ arrly.colorSeparation }}
                  </div>
                  <!-- 金重范围 -->
                  <div style="width:95px" class="styleShopClass">
                    {{ arrly.goldWeightRange }}
                  </div>
                  <!-- 价格范围 -->
                  <div style="width:110px" class="styleShopClass">
                    {{ arrly.priceRange | moneyFilter }}
                  </div>
                  <!-- 尺寸 -->
                  <div style="width:90px" class="styleShopClass">
                    {{ arrly.size }}
                  </div>
                  <!-- 扣子 -->
                  <div style="width:55px" class="styleShopClass">
                    {{ arrly.button }}
                  </div>
                  <!-- 是否可调节 -->
                  <div style="width:70px" class="styleShopClass">
                    {{ arrly.adjustable }}
                  </div>
                  <!-- 商品数量 -->
                  <div
                    style="width:100px;"
                    class="styleShopClass"
                    v-if="item.imgShow == false"
                  >
                    <el-input-number
                      @change="changeParameters('商品数量', arrly)"
                      size="mini"
                      :min="1"
                      v-model="arrly.quantity"
                    ></el-input-number>
                  </div>
                  <div
                    style="width:100px;"
                    class="styleShopClass"
                    v-if="item.imgShow == true"
                  >
                    {{ arrly.quantity }}
                  </div>
                  <!-- 备注 -->
                  <div
                    class="remakShopClass"
                    style="width:90px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block;text-align:center;padding: 0 5px;"
                  >
                    {{ arrly.remark }}
                  </div>
                  <div
                    v-if="!item.imgShow"
                    style="color:#00baff;font-size:20px;cursor:pointer;margin-left:15px"
                    @click.stop="copyData(arrly, index, idx)"
                  >
                    <i class="el-icon-edit"></i>
                  </div>
                  <div
                    v-if="!item.imgShow"
                    style="color:#ff0000;font-size:20px;margin-left:15px;cursor:pointer"
                    @click.stop="deleteData(arrly.id)"
                  >
                    <i class="el-icon-delete"></i>
                  </div>
                  <div
                    v-if="item.imgShow"
                    style="color:#ff0000;margin-left:15px;width: 70px;text-align: center;height: 28px;line-height: 28px;color: #ec9368;font-size: 14px;border: 1px solid #ec9368;border-radius: 5px;cursor: pointer;"
                    @click.stop="getStockbottom(arrly)"
                  >
                    现货列表
                  </div>
                  <!-- 现货弹框 -->
                  <div
                    v-if="arrly.spotShow"
                    class="copyBox"
                    onclick="event.cancelBubble = true"
                    style="width: 1200px;left: -112px;"
                  >
                    <div class="spot_title">现货列表</div>
                    <div class="spot_head">
                      <div class="spot_head_textuer colorClass">材质</div>
                      <div class="spot_head_name colorClass">主石名称</div>
                      <div class="spot_head_name colorClass">主石数量</div>
                      <div class="spot_head_name colorClass">主石重量</div>
                      <div class="spot_head_OneName colorClass">辅石1名称</div>
                      <div class="spot_head_OneName colorClass">辅石1数量</div>
                      <div class="spot_head_OneName colorClass">辅石1重量</div>
                      <div class="spot_head_OneName colorClass">辅石2名称</div>
                      <div class="spot_head_OneName colorClass">辅石2数量</div>
                      <div class="spot_head_OneName colorClass">辅石2重量</div>
                      <div class="spot_head_textuer colorClass">金重</div>
                      <div class="spot_head_textuer colorClass">净度</div>
                      <div class="spot_head_textuer colorClass">色度</div>
                      <div class="spot_head_name colorClass">标签价格</div>
                      <div class="spot_head_textuer colorClass">GIA</div>
                      <div class="spot_head_textuer colorClass">手寸</div>
                      <div class="spot_head_textuer colorClass">操作</div>
                    </div>
                    <div
                      v-for="(item, idx) in stockList"
                      :key="idx"
                      class="spot_head"
                    >
                      <div class="spot_head_textuer">{{ item.texture }}</div>
                      <div class="spot_head_name">{{ item.mainStoneName }}</div>
                      <div class="spot_head_name">
                        {{ item.mainStoneNumber }}
                      </div>
                      <div class="spot_head_name">
                        {{ item.mainStoneWeight }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneNameOne }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneNumberOne }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneWeightOne }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneNameTwo }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneNumberTwo }}
                      </div>
                      <div class="spot_head_OneName">
                        {{ item.assistStoneWeightTwo }}
                      </div>
                      <div class="spot_head_textuer">{{ item.goldWeight }}</div>
                      <div class="spot_head_textuer">
                        {{ item.mainStoneClarity }}
                      </div>
                      <div class="spot_head_textuer">
                        {{ item.mainStoneColour }}
                      </div>
                      <div class="spot_head_name">{{ item.labelPrice }}</div>
                      <div class="spot_head_textuer">
                        {{ item.gia | giaFilter }}
                      </div>
                      <div class="spot_head_textuer">{{ item.ringSize }}</div>
                      <div
                        class="spot_head_textuer"
                        style="color: rgb(255, 90, 90);cursor: pointer;"
                        @click.stop="removeSpot(item)"
                      >
                        删除
                      </div>
                    </div>
                    <div class="pagingClass">
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        @current-change="cartSpotListCurrentPage"
                      ></el-pagination>
                    </div>
                  </div>
                  <!-- 复制弹框 -->
                  <div
                    v-if="arrly.copyListShow"
                    class="copyBox"
                    onclick="event.cancelBubble = true"
                  >
                    <div style="position: relative;">
                      <div
                        class="closeClass"
                        @click.stop="cancelUpdown(index, idx)"
                      >
                        <i class="el-icon-close"></i>
                      </div>
                      <div class="copyBox_content">
                        <div
                          style="display: flex;align-items: center;margin:0 10px 0 20px"
                        >
                          <img :src="copyList.imgPath" alt="" />
                        </div>
                        <div>
                          <div
                            v-if="copyList.goldWeightRange"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选金重：</span
                            >
                            <el-radio-group
                              v-model="copyList.goldWeightRange"
                              v-for="(item, index) in copyList.attrOption
                                .goldWeightRange"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.button"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选扣子：</span
                            >
                            <el-radio-group
                              v-model="copyList.button"
                              v-for="(item, index) in copyList.attrOption
                                .button"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.pricingManner"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选计价方式：</span
                            >
                            <el-radio-group
                              v-model="copyList.pricingManner"
                              v-for="(item, index) in copyList.attrOption
                                .pricingManner"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.size"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选尺寸：</span
                            >
                            <el-radio-group
                              v-model="copyList.size"
                              v-for="(item, index) in copyList.attrOption.size"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.texture"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选材质：</span
                            >
                            <el-radio-group
                              v-model="copyList.texture"
                              v-for="(item, index) in copyList.attrOption
                                .texture"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.colorSeparation"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选色度：</span
                            >
                            <el-radio-group
                              v-model="copyList.colorSeparation"
                              v-for="(item, index) in copyList.attrOption
                                .colorSeparation"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.adjustable"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >是否可调节：</span
                            >
                            <el-radio-group
                              v-model="copyList.adjustable"
                              v-for="(item, index) in copyList.attrOption
                                .adjustable"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div
                            v-if="copyList.priceRange"
                            class="copyBox_content_text"
                          >
                            <span class="copyBox_content_title"
                              >可选价格范围：</span
                            >
                            <el-radio-group
                              v-model="copyList.priceRange"
                              v-for="(item, index) in copyList.attrOption
                                .priceRange"
                              :key="index"
                            >
                              <el-radio-button :label="item"></el-radio-button>
                            </el-radio-group>
                          </div>
                          <div class="copyBox_content_text">
                            <span class="copyBox_content_title"
                              >商品数量：</span
                            >
                            <div style="margin-left: 10px;">
                              <el-input-number
                                size="mini"
                                :min="1"
                                v-model="copyList.quantity"
                              ></el-input-number>
                            </div>
                          </div>
                          <div
                            class="copyBox_content_text"
                            style="margin:5px 0"
                          >
                            <span class="copyBox_content_title"
                              >商品备注：</span
                            >
                            <div style="margin-left: 10px;">
                              <el-input
                                type="textarea"
                                :rows="2"
                                placeholder="请输入商品备注"
                                v-model="copyList.remark"
                              >
                              </el-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="copyBoxSubmit">
                      <div
                        class="copyBoxSubmitTherr"
                        @click.stop="editGet(copyList)"
                      >
                        修改商品
                      </div>
                      <div
                        class="copyBoxSubmitTwo"
                        @click.stop="getSubmitCart(arrly, copyList)"
                      >
                        复制商品
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!withWithoutShow" style="text-align:center;margin:60px 0">
        <img src="../../Img/noData.png" alt />
      </div>
      <div class="modifyBox">
        <div class="modifyBox_left">
          <div style="width:16px;height:16px;margin-right:10px">
            <el-checkbox
              v-model="checkedData"
              @change="ZlfAllproducts"
            ></el-checkbox>
          </div>
          <div style="color:#000000;margin-right:40px;font-size:24px">全选</div>
          <div
            style="color:#ff0000;font-size:24px;cursor:pointer;"
            @click="showdetailbox"
          >
            删除
          </div>
        </div>
        <div class="modifyBox_right">
          <div style="display:flex;margin-right:10px">
            已选
            <div style="color:#ec9368;margin:0 5px">{{ shangp }}</div>
            件商品
          </div>
          <div style="display:flex;margin-right:10px">
            (现货
            <div style="color:#ec9368;margin:0 5px">{{ spotNumber }}</div>
            件,定制
            <div style="color:#ec9368;margin:0 5px">{{ scheduledNUmber }}</div>
            件)
          </div>
          <div style="display:flex;margin-right:20px">
            订单总金额:
            <div style="color:#ec9368;margin:0 5px">
              <!-- {{ shopCarPrice | totalAmount }} -->
            </div>
          </div>
          <div
            style="color:#FFF;width:140px;height:66px;text-align:center;line-height:66px;background:#ec9368;cursor:pointer"
            @click="submitOrder"
          >
            提&nbsp;&nbsp;交
          </div>
        </div>
      </div>
    </div>
    <!-- 购物车删除 -->
    <div class="getDeleteBox">
      <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="1024px"
        center
      >
        <span>确认删除购物车商品吗？</span>
        <span slot="footer" class="dialog-footer">
          <div
            style="width:290px; height:52px;display:inline-block;border:1px solid #000"
            class="nthone"
          >
            <el-button
              @click="centerDialogVisibleClick"
              style="width:280px; height:52px;cursor:pointer;"
              >取 消</el-button
            >
          </div>
          <div
            style="width: 290px; height: 52px;display:inline-block;border:1px solid #ec9368;margin-left:40px"
            class="nthTwo"
          >
            <el-button
              type="primary"
              @click="deletesp()"
              style="width: 280px; height: 52px;cursor:pointer"
              >确 定</el-button
            >
          </div>
        </span>
      </el-dialog>
    </div>
    <!-- 下单填写资料弹框 -->
    <div class="getsubmit">
      <el-dialog
        title="提交订单"
        :visible.sync="showdizhi"
        width="1024px"
        center
      >
        <span>填写下单地址</span>
        <span slot="footer" class="dialog-footer">
          <div class="nameOfbranches publicClass">
            <div
              style="display:inline-block;font-size:20px;color:#000000;margin-right:50px;margin-left:70px"
            >
              网点名称：
            </div>
            <el-select
              filterable
              v-model.trim="networkName"
              :filter-method="networkSearch"
              placeholder="请选择下单网点名称"
              @focus="workNameFpcus"
              @change="changeNetWork"
            >
              <el-option
                v-for="(item, index) in network"
                :key="index"
                :label="item.orgName"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="contactPerson publicClass">
            <div
              style="display:inline-block;font-size:20px;color:#000000;margin-right:50px;margin-left:70px"
            >
              联
              <span style="margin:0 7px">系</span>人：
            </div>
            <el-input
              v-model="linkman"
              filterable
              placeholder="请输入联系人姓名"
            ></el-input>
          </div>
          <div class="contactNumber publicClass">
            <div
              style="display:inline-block;font-size:20px;color:#000000;margin-right:50px;margin-left:70px"
            >
              联系电话：
            </div>
            <el-input
              v-model="phone"
              filterable
              placeholder="请输入联系人电话"
              maxlength="11"
              @input="inputPhone"
            ></el-input>
          </div>
          <div class="remarksBox">
            <div
              style="display:inline-block;font-size:20px;color:#000000;margin-right:50px;margin-left:70px;vertical-align: top"
            >
              备
              <div style="margin-left:34px;display:inline-block;">注：</div>
            </div>
            <el-input
              v-model="orderRemark"
              placeholder="请输入您的备注"
              type="textarea"
              :rows="7"
            ></el-input>
          </div>
          <div style="text-align:center" class="bottomBox">
            <el-button
              type="primary"
              style="width: 370px; height: 52px"
              @click="pushData()"
              >确 定</el-button
            >
          </div>
        </span>
      </el-dialog>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import $ from "jquery";
import Appheader from "../moudel/Appheader";
import bottom from "../bady_bottom/bottom";
export default {
  components: {
    Appheader,
    bottom,
  },
  data() {
    return {
      searchStyleNumber: "",
      stockList: [],
      shoppingCart: [],
      pictureZoom: "",
      copyList: {},
      copyProductRemark: "",
      copyQuantity: "",
      amount: 0,
      idList: [],
      phone: "",
      linkman: "",
      networkName: "",
      networkCoding: "",
      orderType: "",
      isSelect: true,
      showdizhi: false,
      centerDialogVisible: false,
      withWithoutShow: true,
      spotListStatus: true,
      spotListArr: [],
      total: 0,
      pageNum: 1,
      pageSize: 5,
      network: "",
      networkCpoy: "",
      seal: "",
      gia: "",
      idName: "",
      orderRemark: "",
      optionalAttributesData: "",
    };
  },
  computed: {
    checkedData: {
      get() {
        return this.shoppingCart.every((val) => {
          return val.flag == true;
        });
      },
      set() {
        return this.shoppingCart.every((val) => {
          return val.flag == true;
        });
      },
    },
    cartNumber: function() {
      let shangp = 0;
      for (let i = 0; i < this.shoppingCart.length; i++) {
        for (let j = 0; j < this.shoppingCart[i].length; j++) {
          shangp += Number(this.shoppingCart[i][j].quantity);
        }
      }
      return shangp;
    },
    // 总商品数量
    shangp: function() {
      let shangp = 0;
      for (let i = 0; i < this.shoppingCart.length; i++) {
        for (let j = 0; j < this.shoppingCart[i].length; j++) {
          if (this.shoppingCart[i][j].innerLayer) {
            shangp += Number(this.shoppingCart[i][j].quantity);
          }
        }
      }
      return shangp;
    },
    // 现货商品数量
    spotNumber: function() {
      let spotNumber = 0;
      for (let i = 0; i < this.shoppingCart.length; i++) {
        for (let j = 0; j < this.shoppingCart[i].length; j++) {
          if (
            this.shoppingCart[i][j].spots.length > 0 &&
            this.shoppingCart[i][j].innerLayer
          ) {
            spotNumber += Number(this.shoppingCart[i][j].quantity);
          }
        }
      }
      return spotNumber;
    },
    //预定商品数量
    scheduledNUmber: function() {
      let scheduledNUmber = 0;
      for (let i = 0; i < this.shoppingCart.length; i++) {
        for (let j = 0; j < this.shoppingCart[i].length; j++) {
          if (
            this.shoppingCart[i][j].spots.length <= 0 &&
            this.shoppingCart[i][j].innerLayer
          ) {
            scheduledNUmber += Number(this.shoppingCart[i][j].quantity);
          }
        }
      }
      return scheduledNUmber;
    },
  },
  mounted() {
    // 购物车查看
    this.checkGWCSP();
  },
  methods: {
    // 购物车搜索
    getsearchCart() {
      this.checkGWCSP();
    },
    //  改变网点名称
    changeNetWork(value) {
      this.networkName = value.orgName;
      this.networkCoding = value.orgCode;
    },
    networkSearch(val) {
      this.value = val;
      if (val) {
        //val存在
        this.network = this.networkCopy.filter((item) => {
          if (
            !!~item.orgName.indexOf(val) ||
            !!~item.orgName.toUpperCase().indexOf(val.toUpperCase())
          ) {
            return true;
          }
        });
      } else {
        //val为空时，还原数组
        this.network = this.networkCopy;
      }
    },
    //input事件处理
    inputPhone(e) {
      let filtered = e.replace(/[^\d]/g, "");
      if (this.phone != filtered) {
        this.phone = filtered;
      }
    },
    //  点击图片放大
    transferImgSrc(imgPath, item) {
      this.pictureZoom = imgPath;
      if (item.pictureZoomShow == true) {
        item.pictureZoomShow = false;
      } else if (item.pictureZoomShow == false) {
        for (let k = 0; k < this.shoppingCart.length; k++) {
          this.shoppingCart[k].pictureZoomShow = false;
        }
        item.pictureZoomShow = true;
      }
      // 外层循环
      for (let q = 0; q < this.shoppingCart.length; q++) {
        // 内层循环
        for (let j = 0; j < this.shoppingCart[q].length; j++) {
          this.shoppingCart[q][j].copyListShow = false;
        }
      }
      this.$forceUpdate();
    },
    // 复制弹框确定按钮
    getSubmitCart(arrly, copyList) {
      var that = this;
      var url = "/direct/shop-cart/copy";
      that
        .$axios({
          url: url,
          method: "post",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            goldWeightRange: copyList.goldWeightRange,
            gender: copyList.gender,
            remark: copyList.remark,
            gem: copyList.gem,
            button: copyList.button,
            broadHeading: copyList.broadHeading,
            id: copyList.id,
            pricingManner: copyList.pricingManner,
            quantity: copyList.quantity,
            texture: copyList.texture,
            styleNumber: copyList.styleNumber,
            size: copyList.size,
            colorSeparation: copyList.colorSeparation,
            createTime: copyList.createTime,
            imgPath: copyList.imgPath,
            style: copyList.style,
            adjustable: copyList.adjustable,
            category: copyList.category,
            priceRange: copyList.priceRange,
          }),
        })
        .then((re) => {
          if (re.data.code == 200) {
            arrly.copyListShow = false;
            this.$message({
              message: re.data.msg,
              type: "success",
              duration: 1500,
            });
            // 购物车查看
            that.checkGWCSP();
          } else {
            this.$message({
              message: re.data.msg,
              type: "warning",
              duration: 1500,
            });
          }
        });

      that.$forceUpdate();
    },
    //  关闭复制弹框
    cancelUpdown(index, idx) {
      this.shoppingCart[index][idx].copyListShow = false;
      this.$forceUpdate();
    },
    // 取消按鈕
    centerDialogVisibleClick() {
      this.idList = [];
      this.centerDialogVisible = false;
    },
    //删除单条数据
    deleteData(id) {
      this.idList = [];
      this.idList.push(id);
      this.centerDialogVisible = true;
      // 外层循环
      for (let k = 0; k < this.shoppingCart.length; k++) {
        this.shoppingCart[k].pictureZoomShow = false;
        // 内层循环
        for (let j = 0; j < this.shoppingCart[k].length; j++) {
          this.shoppingCart[k][j].copyListShow = false;
          this.shoppingCart[k][j].spotShow = false;
        }
      }
    },
    // 购物车現貨分页按钮
    cartSpotListCurrentPage(pageNum) {
      var that = this;
      that.pageNum = pageNum;
      that.getStockList();
    },
    // 点击现货按钮
    getStockbottom(arrly) {
      if (arrly) {
        this.idName = arrly.id;
      }
      if (arrly.spotShow == false) {
        // 外层循环
        for (let k = 0; k < this.shoppingCart.length; k++) {
          for (let j = 0; j < this.shoppingCart[k].length; j++) {
            this.shoppingCart[k][j].spotShow = false;
          }
        }
        arrly.spotShow = true;
        this.getStockList();
      } else {
        arrly.spotShow = false;
      }
      this.$forceUpdate();
    },
    // 删除现货
    removeSpot(item) {
      var that = this;
      let url = "/direct/shop-cart/spot/delete";
      that
        .$axios({
          method: "DELETE",
          url: url,
          // async:false,
          cache: false,
          data: JSON.stringify({
            shopCartId: item.shopCartId,
            id: item.id,
          }),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 1500,
            });
            that.getStockList();
            that.checkGWCSP();
          }
        });
    },
    //现货列表
    getStockList() {
      var that = this;
      let url =
        "/direct/shop-cart/spot/paging?pageSize=" +
        that.pageSize +
        "&pageNum=" +
        that.pageNum;
      that
        .$axios({
          method: "POST",
          url: url,
          // async:false,
          cache: false,
          data: JSON.stringify({
            shopCartId: this.idName,
          }),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.stockList = res.data.rows;
            that.total = res.data.total;
            if (that.total == 0) {
              this.checkGWCSP();
            }
          }
        });
    },
    //复制修改数据弹框
    copyData(arrly, index, idx) {
      var that = this;
      that.copyList = Object.assign({}, arrly);
      if (that.shoppingCart[index][idx].copyListShow == false) {
        // 外层循环
        for (let k = 0; k < this.shoppingCart.length; k++) {
          this.shoppingCart[k].pictureZoomShow = false;
          // 内层循环
          for (let j = 0; j < this.shoppingCart[k].length; j++) {
            this.shoppingCart[k][j].copyListShow = false;
            this.shoppingCart[k][j].spotShow = false;
          }
        }
        that.shoppingCart[index][idx].copyListShow = true;
      } else if (that.shoppingCart[index][idx].copyListShow == true) {
        that.shoppingCart[index][idx].copyListShow = false;
      }
      that.$forceUpdate();
    },
    // 关闭界面所有弹窗
    shutDown() {
      // 外层循环
      for (let k = 0; k < this.shoppingCart.length; k++) {
        this.shoppingCart[k].pictureZoomShow = false;
        // 内层循环
        for (let j = 0; j < this.shoppingCart[k].length; j++) {
          this.shoppingCart[k][j].copyListShow = false;
          this.shoppingCart[k][j].spotShow = false;
        }
      }
      this.$forceUpdate();
    },
    // 改变商品数量
    changeParameters(res, arrly) {
      this.doTransfer(arrly);
    },
    // 复制弹框修改按钮
    editGet(copyList) {
      this.doTransfer(copyList);
    },
    //修改购物车数据接口
    doTransfer(arrly) {
      var that = this;
      let url = "/direct/shop-cart/edit";
      that
        .$axios({
          method: "POST",
          url: url,
          // async:false,
          cache: false,
          data: JSON.stringify({
            goldWeightRange: arrly.goldWeightRange,
            gender: arrly.gender,
            remark: arrly.remark,
            gem: arrly.gem,
            button: arrly.button,
            broadHeading: arrly.broadHeading,
            id: arrly.id,
            pricingManner: arrly.pricingManner,
            quantity: arrly.quantity,
            texture: arrly.texture,
            styleNumber: arrly.styleNumber,
            size: arrly.size,
            colorSeparation: arrly.colorSeparation,
            createTime: arrly.createTime,
            imgPath: arrly.imgPath,
            style: arrly.style,
            adjustable: arrly.adjustable,
            category: arrly.category,
            priceRange: arrly.priceRange,
          }),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 1500,
            });
            this.checkGWCSP();
          }
        });
    },
    //改变下订单的下拉框样式
    workNameFpcus() {
      $(".el-select-dropdown__item").css("width", "97%");
    },
    // 购物车删除按钮
    showdetailbox() {
      var that = this;
      // that.idList = []
      for (let i = 0; i < that.shoppingCart.length; i++) {
        for (let j = 0; j < that.shoppingCart[i].length; j++) {
          if (that.shoppingCart[i][j].innerLayer) {
            if (!that.idList.includes(that.shoppingCart[i][j].id)) {
              that.idList.push(that.shoppingCart[i][j].id);
            }
          }
        }
      }
      if (that.idList.length <= 0) {
        this.$message({
          message: "至少选择一条商品删除",
          type: "warning",
          duration: 1500,
        });
      } else {
        this.centerDialogVisible = true;
      }
    },
    // 购物车下单按钮
    submitOrder() {
      var that = this;
      that.idList = [];
      for (let i = 0; i < that.shoppingCart.length; i++) {
        for (let j = 0; j < that.shoppingCart[i].length; j++) {
          if (that.shoppingCart[i][j].innerLayer) {
            if (!that.idList.includes(that.shoppingCart[i][j].id)) {
              that.idList.push(that.shoppingCart[i][j].id);
            }
          }
        }
      }
      if (that.idList.length <= 0) {
        this.$message({
          message: "至少选择一条商品下单",
          type: "warning",
          duration: 1500,
        });
      } else {
        that.getUserData();
        that.showdizhi = true;
        var userData = JSON.parse(window.localStorage.getItem("userData"));
        that.network = userData.siteList;
        that.networkCopy = userData.siteList;
      }
    },
    // 确定删除按钮
    deletesp() {
      var that = this;
      var url = "/direct/shop-cart/delete?shopCartIds=" + that.idList;
      that
        .$axios({
          url: url,
          method: "DELETE",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            that.centerDialogVisible = false;
            that.checkGWCSP();
            $(".shoppingCart_bodyFather").css("background", "#fff");
            $(".shoppingCart_body_background").css("background", "#fff");
            that.idList = [];
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 1500,
            });
          }
        });
    },
    // 获取上次的下单信息
    getUserData() {
      this.$axios({
        url: "/direct/order/last/info",
        method: "GET",
        cache: false,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;charset=UTF-8",
          "T-token": JSON.parse(localStorage.getItem("userData")).token,
        },
      }).then((re) => {
        if (re.data.code == 200 && re.data.data != null) {
          this.phone = re.data.data.phone;
          this.linkman = re.data.data.linkman;
          this.networkName = re.data.data.networkName;
          this.orderType = re.data.data.orderType;
          this.isSelect = false;
          this.networkCoding = re.data.data.networkCode;
        }
      });
    },
    // 商品全选
    ZlfAllproducts(e) {
      if (e == true) {
        $(".shoppingCart_bodyFather").css("background", "#fff7f2");
        $(".shoppingCart_body_background").css("background", "#fff7f2");
      } else if (e == false) {
        $(".shoppingCart_bodyFather").css("background", "#fff");
        $(".shoppingCart_body_background").css("background", "#fff");
      }
      if (e) {
        this.shoppingCart = this.shoppingCart.map((val) => {
          val.map((res) => {
            res.innerLayer = true;
          });
          val.flag = true;
          return val;
        });
      } else {
        this.shoppingCart = this.shoppingCart.map((val) => {
          val.map((res) => {
            res.innerLayer = false;
          });
          val.flag = false;
          return val;
        });
      }
    },
    // 内层开关
    innerLayer(index, arrly, item, idx) {
      if (arrly.innerLayer == false) {
        item.flag = false;
        $(".shoppingCart_bodyFather")
          .eq(index)
          .find(".shoppingCart_body_background")
          .eq(idx)
          .css("background", "#fff");
        $(".shoppingCart_bodyFather")
          .eq(index)
          .css({ background: "#fff", border: "1px solid #EFE6D4" });
      } else {
        $(".shoppingCart_bodyFather")
          .eq(index)
          .find(".shoppingCart_body_background")
          .eq(idx)
          .css("background", "#fff7f2");
        var flag = item.every((val) => val.innerLayer == true);
        item.flag = flag;
        if (flag == true) {
          $(".shoppingCart_bodyFather")
            .eq(index)
            .css({ background: "#fff7f2", border: "1px solid #EEE4D1" });
        }
      }
      this.$set(this.shoppingCart, index, item);
      this.$forceUpdate();
    },
    // 每款外层开关
    changeCheckbox(i, e) {
      if (e.flag == true) {
        for (let i = 0; i < e.length; i++) {
          e[i].innerLayer = true;
        }
        $(".shoppingCart_bodyFather")
          .eq(i)
          .css({ background: "#fff7f2", border: "1px solid #EFE6D4" });
        $(".shoppingCart_bodyFather")
          .eq(i)
          .find(".shoppingCart_body_background")
          .css("background", "#fff7f2");
      } else if (e.flag == false) {
        for (let i = 0; i < e.length; i++) {
          e[i].innerLayer = false;
        }
        $(".shoppingCart_bodyFather")
          .eq(i)
          .css({ background: "#fff", border: "1px solid #EEE4D1" });
        $(".shoppingCart_bodyFather")
          .eq(i)
          .find(".shoppingCart_body_background")
          .css("background", "#fff");
      }
      this.$set(this.shoppingCart, i, e);
      this.$forceUpdate();
    },
    // 购物车查看
    checkGWCSP() {
      var that = this;
      var pageSize = 9999;
      var pageNum = 1;
      var url =
        "/direct/shop-cart/paging?pageSize=" + pageSize + "&pageNum=" + pageNum;
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json;charset=UTF-8",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            styleNumber: that.searchStyleNumber,
          }),
        })
        .then((res) => {
          that.shoppingCart = [];
          if (res.data.code == 0) {
            for (let i = 0; i < res.data.rows.length; i++) {
              res.data.rows[i].flag = false;
              res.data.rows[i].pictureZoomShow = false;
              that.shoppingCart.push(res.data.rows[i]);
            }
            if (that.shoppingCart.length > 0) {
              that.withWithoutShow = true;
            } else {
              that.withWithoutShow = false;
            }
            // 外层循环
            for (let k = 0; k < that.shoppingCart.length; k++) {
              for (let j = 0; j < that.shoppingCart[k].length; j++) {
                if (that.shoppingCart[k][j].type == 1) {
                  that.shoppingCart[k].imgShow = false;
                } else if (that.shoppingCart[k][j].type == 2) {
                  that.shoppingCart[k].imgShow = true;
                }
                that.shoppingCart[k][j].innerLayer = false;
                that.shoppingCart[k][j].copyListShow = false;
                that.shoppingCart[k][j].spotShow = false;
              }
            }
          }
        });
    },
    // 确定下单按钮
    pushData() {
      var that = this;
      var networkCode = that.networkCoding;
      var networkName = that.networkName;
      var orderRemark = that.orderRemark;
      var linkman = that.linkman;
      var phone = that.phone;
      var url = "/direct/order/generate";
      that
        .$axios({
          url: url,
          method: "post",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            networkCode: networkCode,
            networkName: networkName,
            remark: orderRemark,
            linkman: linkman,
            phone: phone,
            shopCartIds: that.idList,
          }),
        })
        .then((re) => {
          if (re.data.code == 200) {
            this.$confirm("提交成功", "提示", {
              confirmButtonText: "继续下单",
              cancelButtonText: "查看订单",
              type: "success",
            })
              .then(() => {
                that.checkGWCSP();
                that.idList = [];
              })
              .catch(() => {
                that.idList = [];
                that.$router.push("/CommodityOrder");
              });
            this.showdizhi = false;
            $(".shoppingCart_bodyFather").css("background", "#fff");
            $(".shoppingCart_body_background").css("background", "#fff");
          } else if (re.data.code == 50003) {
            for (let k = 0; k < that.shoppingCart.length; k++) {
              for (let j = 0; j < that.shoppingCart[k].length; j++) {
                for (let i = 0; i < re.data.data.length; i++) {
                  if (that.shoppingCart[k][j].id == re.data.data[i]) {
                    $(".shoppingCart_bodyFather")
                      .eq(k)
                      .find(".shoppingCart_body_background")
                      .eq(j)
                      .css({ background: "#f3f3f3", color: "#999" });
                  }
                }
              }
            }
            this.$message({
              message: re.data.msg,
              type: "warning",
              duration: 1500,
            });
            this.showdizhi = false;
          } else {
            this.$message({
              message: re.data.msg,
              type: "warning",
              duration: 1500,
            });
            this.showdizhi = true;
            $(".shoppingCart_bodyFather").css("background", "#fff");
            $(".shoppingCart_body_background").css("background", "#fff");
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.statusImg {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  img {
    width: 40px;
    height: 40px;
  }
}
.shoppingCart_head .el-input {
  display: block;
}
.shoppingCart_head /deep/ .el-input__inner {
  border: 1px solid #ec9368;
  border-radius: 30px !important;
}
.shoppingCart_head /deep/ .el-input__icon {
  height: 33px !important;
  line-height: 33px !important;
}
.shoppingCart {
  width: 1200px;
  margin: 0 auto;
  min-height: 600px;
  .shoppingCart_head {
    display: flex;
    justify-content: space-between;
  }
  .shoppingCart_bodyFather {
    border: 1px solid #ede2ce;
    margin-top: 12px;
    .shoppingCart_body {
      width: 100%;
      min-height: 105px;
      display: flex;
      font-size: 0;
      position: relative;
      .shoppingCart_body_child {
        display: flex;
        align-items: center;
        img {
          width: 70px;
          height: 70px;
        }
      }
      .checkBoxHade {
        margin: 10px 7px 0 10px;
        .el-checkbox {
          font-size: 0;
        }
        ::v-deep .el-checkbox__inner {
          width: 16px !important;
          height: 16px !important;
        }
        ::v-deep .el-checkbox__inner::after {
          height: 9px !important;
          left: 5px !important;
          top: 0px !important;
          width: 3px !important;
        }
        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #ec9368;
          border-color: #ec9368;
        }
        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #dcdfe6 !important;
        }
        ::v-deep .el-checkbox__inner:hover {
          border-color: #ec9368 !important;
        }
        ::v-deep .el-checkbox__inner:focus {
          border-color: #ec9368 !important;
        }
      }
      .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 24px 0;
      }
      .shoppingCart_body_text:last-child {
        border: none !important;
      }
      .shoppingCart_body_text {
        display: flex;
        min-height: 34px;
        align-items: center;
        flex-wrap: wrap;
        position: relative;
        color: #000;
        // 复制box
        .copyBox {
          position: absolute;
          box-sizing: border-box;
          background: #fff;
          z-index: 999;
          border: 1px solid #ec9368;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          top: 43px;
          width: 100%;
          .closeClass {
            cursor: pointer;
            position: absolute;
            right: 3px;
            top: 3px;
            font-size: 0;
            z-index: 999;
            i {
              font-size: 24px;
            }
          }
          .copyBox_content {
            display: flex;
            padding: 10px 30px 10px 10px;
            img {
              width: 150px;
              height: 150px;
            }
            ::v-deep
              .el-radio-button__orig-radio:checked
              + .el-radio-button__inner {
              background-color: #ec9368;
              border-color: #ec9368;
            }
            ::v-deep .el-radio-button__inner {
              padding: 5px;
              font-size: 14px;
              margin-left: 10px;
              min-width: 100px;
            }
            .copyBox_content_text {
              min-height: 35px;
              display: flex;
              align-items: center;
              .copyBox_content_title {
                display: inline-block;
                width: 110px;
                text-align: right;
              }
              ::v-deep .el-textarea {
                width: 670px;
              }
            }
            ::v-deep .el-input-number--mini {
              width: 100px;
            }
          }
          .copyBoxChild {
            display: flex;
            align-items: center;
            margin: 10px 0;
          }
          .copyBoxSubmit {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0;
            .copyBoxSubmitOne {
              width: 100px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              background: #fff;
              color: #000;
              border: 1px solid #ede2ce;
              border-radius: 20px;
              margin-right: 20px;
              cursor: pointer;
            }
            .copyBoxSubmitTherr {
              width: 100px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              background: skyblue;
              color: #fff;
              border-radius: 20px;
              margin-right: 20px;
              cursor: pointer;
            }
            .copyBoxSubmitTwo {
              width: 100px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              background: rgb(236, 147, 104);
              color: #fff;
              border-radius: 20px;
              cursor: pointer;
            }
          }
          .spot_title {
            width: 100%;
            height: 44px;
            line-height: 44px;
            text-align: center;
            background: #f4c7b1;
            font-size: 18px;
            color: #000;
          }
          .spot_head {
            display: flex;
            border-top: 1px solid #ec9368;
            .spot_head_textuer {
              width: 60px;
              display: flex;
              justify-content: center;
              min-height: 40px;
              align-items: center;
              border-right: 1px solid #ec9368;
              box-sizing: content-box;
            }
            .spot_head_textuer:last-child {
              border-right: none;
            }
            .colorClass {
              color: #000;
            }
            .spot_head_name {
              min-height: 40px;
              width: 70px;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: content-box;
              border-right: 1px solid #ec9368;
            }
            .spot_head_OneName {
              min-height: 40px;
              border-right: 1px solid #ec9368;
              width: 80px;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: content-box;
            }
          }
          .pagingClass {
            display: flex;
            border-top: 1px solid #ec9368;
            justify-content: center;
            align-items: center;
            padding: 20px 0;
            ::v-deep
              .el-pagination.is-background
              .el-pager
              li:not(.disabled).active {
              background: #ec9368;
            }
          }
        }
        .childecked {
          width: 20px;
          .el-checkbox {
            font-size: 16px !important;
          }
          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
          .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #ec9368;
            border-color: #ec9368;
          }
          ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
            border-color: #dcdfe6 !important;
          }
          ::v-deep .el-checkbox__inner:hover {
            border-color: #ec9368 !important;
          }
          ::v-deep .el-checkbox__inner:focus {
            border-color: #ec9368 !important;
          }
        }
        .styleShopClass {
          // width: 90px;
          min-height: 21px;
          display: flex;
          justify-content: center;
          align-items: center;
          .invertedTriangle {
            width: 0;
            height: 0;
            margin-left: 3px;
            border-right: 5px solid transparent;
            border-left: 5px solid transparent;
            border-top: 5px solid #515151;
          }
        }
        .quantitydropDownBox {
          position: absolute;
          width: 170px;
          z-index: 999;
          left: -46px;
          background: #fff;
          border: 1px solid #ebeef5;
          font-size: 14px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          word-break: break-all;
          text-align: center;
          .el-input-number--mini {
            margin-top: 10px;
            margin-bottom: 10px;
          }
          ::v-deep .el-input__inner {
            color: rgb(236, 147, 104) !important;
          }
        }
        .remakdropDownBox {
          position: absolute;
          width: 600px;
          z-index: 999;
          left: -254px;
          background: #fff;
          border: 1px solid #ebeef5;
          font-size: 14px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          word-break: break-all;
          .remakdropDownBoxChild {
            margin: 10px;
          }
          .remakdropDownBoxSubmit {
            text-align: center;
            font-size: 18px;
            cursor: pointer;
            width: 100px;
            margin: auto;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
        .ringSizedropDownBox {
          position: absolute;
          min-height: 52px;
          width: 338px;
          z-index: 999;
          left: -122px;
          background: #fff;
          border: 1px solid #ebeef5;
          font-size: 14px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          word-break: break-all;
          .el-radio-group {
            margin-top: 19px;
            margin-left: 20px;
          }
          .textureDropDownBoxChild:last-child {
            margin-bottom: 10px;
          }
          .textureDropDownBoxChild {
            display: inline-block;
            min-width: 60px;
            text-align: center;
            padding: 0 5px;
            line-height: 30px;
            height: 30px;
            margin-left: 10px;
            color: #000;
            margin-top: 10px;
            border: 1px solid #f0f0f0;
          }
          .activeMainStoneShowCleanessChild:last-child {
            margin-bottom: 10px;
          }
          .activeMainStoneShowCleanessChild {
            display: inline-block;
            width: 100px;
            text-align: center;
            line-height: 30px;
            height: 30px;
            margin-left: 10px;
            background: #ec9368;
            margin-top: 10px;
            color: #fff;
            border: 1px solid #f0f0f0;
          }
          .activeOptionalAttributesChild:last-child {
            margin-bottom: 10px;
          }
          .activeOptionalAttributesChild {
            display: inline-block;
            min-width: 60px;
            padding: 0 5px;
            text-align: center;
            line-height: 30px;
            height: 30px;
            margin-left: 10px;
            background: #ec9368;
            margin-top: 10px;
            color: #fff;
            border: 1px solid #f0f0f0;
          }
        }
        .mainShopClass {
          width: 92px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .goldShopClass {
          width: 90px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .moneyShopClass {
          width: 170px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .remakShopClass {
          width: 90px;
          min-height: 21px;
          display: flex;
          justify-content: center;
          align-items: center;
          .invertedTriangle {
            width: 0;
            height: 0;
            margin-left: 3px;
            border-right: 5px solid transparent;
            border-left: 5px solid transparent;
            border-top: 5px solid #515151;
          }
        }
        .marginClass {
          margin: 15px 0 0 0;
        }
      }
    }
  }
  .modifyBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 56px;
    .modifyBox_left {
      display: flex;
      // font-size: 24px;
      align-items: center;
      height: 66px;
      ::v-deep .el-checkbox__input {
        vertical-align: inherit;
      }
      ::v-deep .el-checkbox__inner {
        width: 16px !important;
        height: 16px !important;
      }
      ::v-deep .el-checkbox__inner::after {
        height: 9px !important;
        left: 5px !important;
        top: 0px !important;
        width: 3px !important;
      }
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ec9368;
        border-color: #ec9368;
      }
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6 !important;
      }
      ::v-deep .el-checkbox__inner:hover {
        border-color: #ec9368 !important;
      }
      ::v-deep .el-checkbox__inner:focus {
        border-color: #ec9368 !important;
      }
    }
    .modifyBox_right {
      display: flex;
      font-size: 16px;
      align-items: center;
    }
  }
}
.el-select-dropdown__item {
  width: 97%;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #fff2ea;
}
::v-deep .el-input-number--mini .el-input-number__decrease,
.el-input-number--mini .el-input-number__increase {
  width: 22px !important;
}
::v-deep .el-input-number__increase {
  width: 22px !important;
}
::v-deep .el-input-number--mini .el-input__inner {
  padding-left: 25px;
  padding-right: 25px;
}
</style>

<style scope>
.shoppingCart_head .el-input__inner {
  height: 33px !important;
  line-height: 33px !important;
}
.getDeleteBox .el-dialog__header {
  padding: 0 !important;
  height: 78px;
  line-height: 78px;
  background: #fff2ea;
}
.nthone .el-button:hover {
  width: 290px !important;
}
.nthTwo .el-button:hover {
  width: 290px !important;
}
.nthone .el-button {
  background: #000 !important;
  color: #fff !important;
  font-size: 20px !important;
  border: none !important;
}
.nthTwo .el-button {
  background: #ec9368 !important;
  color: #fff !important;
  font-size: 20px !important;
}
.nthTwo .el-button--primary {
  border: none !important;
}
.getDeleteBox .el-dialog--center {
  text-align: left;
}
.getDeleteBox .el-dialog__title {
  margin-left: 70px;
  font-size: 30px;
  color: #010101;
}
.getDeleteBox .el-dialog--center {
  height: 412px;
}
.getDeleteBox .el-dialog--center .el-dialog__body {
  padding: 0 !important;
  font-size: 36px;
  text-align: center;
  color: #010101;
  margin: 78px 0 90px 0;
}
.getDeleteBox .el-dialog__footer {
  padding: 0;
}
.getDeleteBox .el-dialog--center .el-dialog__footer {
  text-align: center;
}
.getDeleteBox .el-dialog__headerbtn .el-dialog__close {
  font-size: 30px;
  margin-right: 10px;
}
.publicClass {
  height: 64px;
  line-height: 64px;
  margin-top: 20px;
}
.nameOfbranches {
  margin-top: 46px;
}
.nameOfbranches .el-input {
  width: 752px;
}
.contactPerson .el-input {
  width: 752px;
}
.contactNumber .el-input {
  width: 752px;
}
.orderType .el-input {
  width: 752px;
}
.remarksBox .el-textarea {
  width: 752px;
}
.remarksBox {
  margin: 32px 0 36px 0;
}
.bottomBox .el-button--primary {
  background: #ec9368 !important;
  border-color: #ec9368 !important;
}
.bottomBox .el-button--primary:focus {
  border: none !important;
}
.getsubmit .el-dialog--center .el-dialog__body {
  display: none;
}
.getsubmit .el-dialog__footer {
  padding: 0 !important;
}
.getsubmit .el-dialog__header {
  width: 1024px !important;
  height: 78px !important;
  line-height: 78px !important;
  background: #fff2ea !important;
  padding: 0 !important;
}
.getsubmit .el-dialog__header .el-dialog__headerbtn {
  font-size: 30px !important;
}
.getsubmit .el-dialog--center {
  text-align: left !important;
}
.getsubmit .el-dialog__title {
  margin-left: 70px;
  font-size: 30px;
  color: #010101;
}
.getsubmit .el-dialog {
  height: 804px;
}
.bottomBox {
  width: 380px;
  border: 1px solid #ec9368;
  margin: 0 auto;
}
.bottomBox .el-button--primary:hover {
  width: 380px !important;
  border-radius: 0;
}
.el-button {
  border-radius: 0 !important;
}
[v-cloak] {
  display: none;
}
.pictureZoom {
  width: 400px;
  height: 400px;
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  z-index: 999;
  left: 50%;
}
.pictureZoom img {
  width: 400px !important;
  height: 400px !important;
}
.searchClass {
  cursor: pointer;
  height: 33px;
  line-height: 33px;
  background: #ec9368;
  color: #fff;
  width: 60px;
  text-align: center;
  font-size: 16px;
  border-radius: 30px;
  margin-left: 10px;
}
</style>
